import { render, staticRenderFns } from "./ButtonTimer.vue?vue&type=template&id=21b0bef9&"
import script from "./ButtonTimer.vue?vue&type=script&lang=js&"
export * from "./ButtonTimer.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTimer.vue?vue&type=style&index=0&id=21b0bef9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports